<template>
    <div id="footer" class="text-center py-5">
        <h5 id="author">
            Made with <HeartIcon></HeartIcon> by Deepjyoti Barman
        </h5>
        <div id="social-buttons" class="pt-3" align="center">
            <a href="https://github.com/deepjyoti30" target="_blank" class="my-3 github">
                <GithubIcon size="20"></GithubIcon> Check other projects
            </a>
            <a href="https://twitter.com/DeepBarman30" target="_blank" class="my-3 twitter">
                <TwitterIcon size="20"></TwitterIcon> Get Updates
            </a>
            <a href="mailto:deep.barman30@gmail.com" target="_blank" class="my-3 gmail">
                <MailIcon size="20"></MailIcon> Get in touch
            </a>
            <a href="https://deepjyoti30.github.io" target="_blank" class="my-3 personal">
                <UserIcon size="20"></UserIcon> Check Personal Page
            </a>
        </div>
    </div>
</template>

<script>
import { HeartIcon, GithubIcon, TwitterIcon, UserIcon, MailIcon } from "vue-feather-icons";

export default {
    name: "Footer",
    components: {
        HeartIcon,
        GithubIcon,
        TwitterIcon,
        UserIcon,
        MailIcon
    },
    methods: {
        addAnimationEach(el) {
            el.classList.add('fadeInUp');
        },
        addAnimation() {
            /**
             * Animate the possible things.
             */
            this.addAnimationEach(document.getElementById("author"));
            document.getElementById("social-buttons").getElementsByTagName("a").forEach(el => {
                this.addAnimationEach(el);
            })
        }
    },
    mounted() {
        this.addAnimation();
    },
}
</script>

<style lang="scss">
$github: #121212;
$twitter: #1da1f2;
$personal: #4CAF50;
$gmail: #D44638;

    #footer {
        min-height: 250px;

        #author {
            color: lighten(#212121, 20);
        }
        
        #social-buttons {
            a {
                width: 250px;
                display: block;
                padding: 8px 5px;
                font-size: 13px;
                border-radius: 5px;
                text-transform: uppercase;
                font-weight: 600;

                &:hover {
                    text-decoration: none;
                }
            }

            .github {
                background: $github;
                color: #fafafa;

                &:hover {
                    background: lighten($github, 25);
                }
            }

            .twitter {
                background: lighten($twitter, 40);
                color: $twitter;

                &:hover {
                    background: lighten($twitter, 35);
                }
            }

            .personal {
                background: lighten($personal, 40);
                color: $personal;

                &:hover {
                    background: lighten($personal, 35);
                }
            }

            .gmail {
                background: lighten($gmail, 40);
                color: $gmail;

                &:hover {
                    background: lighten($gmail, 35);
                }
            }
        }
    }
</style>